/* eslint-disable react/prop-types */
import React from 'react'

import Checkbox from "components/CheckboxCustom";
import ReserveDate from "components/SearchComponents/ReserveDate";
import Passengers from "components/SearchComponents/Passengers";
import Offers from "components/SearchComponents/Offers"
import SearchLocation from "components/SearchComponents/SearchLocation";

import {useApp} from "contexts/AppContext";
import {
    changeLocationDepartureAction,
    changeLocationArrivalAction,
    changeOfferAirfareAction,
    changeOnlyDepartureAction,
    changeDatesAirfareAction
} from "contexts/reducers/airfare/actions";
import SearchLocationAirfare from "../SearchComponents/SearchLocationAirFare";
import Class from "../SearchComponents/Class";

export function FormSearchAirfare() {

    const { airfareState, airfareDispatch} = useApp()
    const { locationDeparture, locationArrival, datesSearchAirfare, offersAirfare, onlyDeparture } = airfareState

    const searchLocationDeparture = (local) => {
        airfareDispatch(changeLocationDepartureAction(local))
    }

    const searchLocationArrival = (local) => {
        airfareDispatch(changeLocationArrivalAction(local))
    }

    const changeOffers = (offers) => {
        airfareDispatch(changeOfferAirfareAction(offers))
    }

    const handleChangeOnlyDeparture = (e) => {
        const { checked } = e.target
        airfareDispatch(changeOnlyDepartureAction(checked))
    }

    const changeDates = (dates) => {
        airfareDispatch(changeDatesAirfareAction(dates[0]))
    }

    return (
        <div className="box-search">
            <div className="row">
                <div className="col-6">
                    <SearchLocationAirfare
                        placeholder="Origem"
                        location={locationDeparture}
                        onChange={searchLocationDeparture}
                    />
                </div>
                <div className="col-6">
                    <SearchLocationAirfare
                        placeholder="Destino"
                        location={locationArrival}
                        onChange={searchLocationArrival}
                    />
                </div>
            </div>

            <ReserveDate
                onlyStartDate={onlyDeparture}
                rangeDates={datesSearchAirfare}
                onChange={changeDates}
                label="Selecione as datas de ida e volta"
                labelStartDate="Ida"
                labelEndDate="Volta"
            />

            <Checkbox
                onChange={(e) => handleChangeOnlyDeparture(e)}
                checked={onlyDeparture}
                label="Somente ida"
            />

            <div className="row">
                <div className="col-12">
                    <Passengers />
                </div>
                {/* <div className="col-6">
                    <Class />
                </div> */}
            </div>

            <Offers
                offers={offersAirfare}
                changeOffers={changeOffers}
            />
        </div>
    )
}
